module.exports = __webpack_public_path__ + "6a9eda61d0cc2c156e4cfe0ce004cc03.png";